import React from 'react';
import { Section } from './ui/Section';
import { Search, BookOpen, ListChecks, HeartPulse } from 'lucide-react';
export function NewHowItWorks() {
  const steps = [{
    icon: Search,
    title: 'Paso 1: Identificás',
    desc: 'Reconocés el problema o malestar que está ocurriendo en casa.'
  }, {
    icon: BookOpen,
    title: 'Paso 2: Buscás',
    desc: 'Abrís el tomo correspondiente en tu celular o computadora.'
  }, {
    icon: ListChecks,
    title: 'Paso 3: Seguís',
    desc: 'Leés las instrucciones claras y preparás la solución natural.'
  }, {
    icon: HeartPulse,
    title: 'Paso 4: Aplicás',
    desc: 'Aplicás la solución y ves los resultados rápidamente.'
  }];
  return <Section className="bg-cream py-24" data-id="element-156">
      <div className="max-w-5xl mx-auto" data-id="element-157">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-16" data-id="element-158">
          Así funciona el sistema
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 relative" data-id="element-159">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-sage-mist/50 -z-10" data-id="element-160" />

          {steps.map((step, idx) => <div key={idx} className="relative flex flex-col items-center text-center" data-id="element-161">
              <div className="w-24 h-24 rounded-full bg-white shadow-md border border-sage-mist flex items-center justify-center mb-6 relative z-10" data-id="element-162">
                <step.icon className="w-10 h-10 text-moss" data-id="element-163" />
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-honey text-forest-deep font-bold flex items-center justify-center shadow-sm" data-id="element-164">
                  {idx + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold text-forest-deep mb-3" data-id="element-165">
                {step.title}
              </h3>
              <p className="text-forest/80 leading-relaxed" data-id="element-166">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}